import React from "react";
import { FormElements } from "../../../../../../../shared/bootstrap/form/FormElements";
import { useLanguageForShared } from "../../../../../../../shared/utils/languages/useLanguageForShared";
import { concentratorType } from "../../../../../../../shared_lsi_sg/concentratorData";

const pathologySample = {
  COPD: "BPCO",
  OSAS: "OSAS",
  COPDSAS: "BPCO-OSAS",
  OHS: "OHS",
  CSA: "CSAS",
  RestrictivePathology: "Patologia restrittiva",
  NeuroMuscularDisease: "Malattia neuro-muscolare",
  Other: "Altro",
  Obesity: "Obesità",
  Asthma: "Asma",
  RespiratoryFailure: "Insufficienza respiratoria",
  HeartFailure: "Insufficienza cardiaca",
  KidneyFailure: "Insufficienza renale",
  Hyperthyroidism: "Ipertiroidismo",
  Hypothyroidism: "Ipotiroidismo",
  IschemicHeartDisease: "Cardiopatia ischemica",
  Cerebrovascular: "M. Cerebrovascolare",
  Diabetes: "Diabete II",
  RLS_PLM: "RLS/PLM",
  Insomnia: "Insonnia",
  Anxiety: "Ansia",
  Parkinson: "Parkinson"
};

const ConcentratorSelectors = ({ dataForm, changeValue, errors, isSubmit, templateType = "fixed", hideValidUntil = false }) => {
  const { t } = useLanguageForShared();

  const getConcentratorOptions = () => {
    if (templateType === "portable") {
      return [
        {
          label: t("concentrator.portable"),
          value: concentratorType.portable
        },
        {
          label: t("concentrator.transportable"),
          value: concentratorType.transportable
        }
      ];
    }
    // fixed
    return [
      {
        label: t("concentrator.fixed"),
        value: concentratorType.fixed
      },
      {
        label: t("concentrator.fixed_portable"),
        value: concentratorType.fixed_portable
      },
      {
        label: t("concentrator.fixed_transportable"),
        value: concentratorType.transportable
      }
    ];
  };

  const formStructure = [
    {
      name: "pathology",
      type: "select",
      label: `${t("common.pathologies")}*`,
      options: Object.keys(pathologySample).map((ele) => ({
        label: t(`pathology.${ele}`),
        value: ele
      })),
      dataElement: {
        type: "text",
        multi: true
      },
      col: { xs: "12", sm: "12", lg: "4", xl: "4" }
    },
    {
      name: "concentratorType",
      type: "select",
      label: `${t("common.concentrator")}*`,
      options: getConcentratorOptions(),
      dataElement: {
        type: "text"
      },
      col: { xs: "12", sm: "12", lg: "4", xl: "4" }
    },
    {
      name: "validUntil",
      type: "input",
      label: t("prescription.template.validUntil"),
      dataElement: { type: "date" },
      extra: { type: "datePicker" },
      col: { xs: "12", sm: "12", lg: "4", xl: "4" },
      _hideField: hideValidUntil
    },
    ...(dataForm?.pathology?.includes("Other") ? [{
      name: "otherPathologies",
      type: "input",
      label: `${t("common.otherPathologies")}`,
      dataElement: {
        placeholder: t("common.otherPathologies_placeholder"),
        type: "text"
      },
      col: { xs: "12", sm: "12", lg: "4", xl: "4" }
    }] : [])
  ].filter((f) => !f._hideField);

  return (
    <FormElements
      structure={formStructure}
      dataForm={dataForm}
      changeValue={changeValue}
      errors={errors}
      isSubmit={isSubmit}
    />
  );
};

export default ConcentratorSelectors;
